import { InjectionToken } from '@angular/core';
import { ActionsApi } from '../models/actions.model';

export const ACTIONS_API = new InjectionToken<ActionsApi>('ACTIONS_API');
